<div class="kal-option__selection"
     [class.kal-option__selection--active]="active"
     [class.kal-option__selection--highlighted]="isHighlighted"
     [class.kal-option__selection--disabled]="disabled"
     [class.kal-option__selection--hidden]="hidden"
     (click)="emitSelectionEvent($event)">
  <kal-checkbox
      [formControl]="formControl"
      *ngIf="checkbox">
    </kal-checkbox>
  <ng-content></ng-content>
</div>

